export enum UTMSources {
    lensstudio = "lensstudio",
    submission = "submission",
}
